import { convertWholesalerUserToSegmentUser } from './segmentUser'
import { convertElvantiCartItemsToSegment } from './utils'

const DEFAULT_AFFILIATION = 'Paramount Liquor'

export const segmentTrackCustom = (eventName, properties = null) => {
  window?.analytics?.track(eventName, properties)
}

export const segmentTrackParser = (dataType, properties = null) => {
  if (dataType === 'contact') {
    return segmentTrackContactUs(properties)
  }
}

export const getAbsoluteProductURL = (url) => {
  return `${window.location.origin}/product/${url}`
}

export const segmentTrackWholesalerSignup = (userData) => {
  const UserId = userData?.ID

  const segmentUserData = convertWholesalerUserToSegmentUser(userData)

  /**
   * As requested, change from `Wholesaler Sign Up` to `Customer Sign up`
   */
  segmentTrackCustom('Customer Sign Up', {
    ...segmentUserData,
    UserId,
  })
}

export const segmentTrackContactUs = (userData) => {
  const FullName = userData?.FullName
  const Email = userData?.Email
  const Phone = userData?.Phone
  const Message = userData?.Message

  segmentTrackCustom('Contact Us', {
    fullName: FullName || '',
    email: Email || '',
    mobile: Phone || '',
    message: Message || '',
  })
}

export const segmentTrackOrderCompleted = (cartItems, cartId, cart) => {
  segmentTrackCustom('Order Completed', {
    checkout_id: cartId,
    order_id: cartId,
    affiliation: DEFAULT_AFFILIATION,
    total: parseFloat(cart?.total).toFixed(2),
    subtotal: parseFloat(cart?.subtotal).toFixed(2),
    revenue: parseFloat(cart?.total).toFixed(2),
    tax: parseFloat(cart?.tax).toFixed(2),
    discount: parseFloat(cart?.discount).toFixed(2),
    currency: 'aud',
    coupon: cart?.coupon,
    products: convertElvantiCartItemsToSegment(cartItems),
  })
}
